<template>
    <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
            <div class="card bg-secondary shadow border-0">
                <!-- <div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3">
                        <small>Sign up with</small>
                    </div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div> -->
                <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <small>Sign up with credentials</small>
                    </div>
                    <form role="form">
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="First Name" :class="{'input-danger': firstNameErr}"
                                    addon-left-icon="ni ni-hat-3" @keyup="firstNameErr = false"
                                    v-model="model.firstName">
                        </base-input>
                        <span v-show="firstNameErr" class="text-danger" v-text="firstNameMsg"></span>

                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Last Name" :class="{'input-danger': lastNameErr}"
                                    addon-left-icon="ni ni-hat-3" @keyup="lastNameErr = false"
                                    v-model="model.lastName">
                        </base-input>
                        <span v-show="lastNameErr" class="text-danger" v-text="lastNameMsg"></span>

                        <base-input class="input-group-alternative mb-3" type="email"
                                    placeholder="Email" :class="{'input-danger': emailErr}"
                                    addon-left-icon="ni ni-email-83" @keyup="emailErr = false"
                                    v-model="model.email">
                        </base-input>
                        <span v-show="emailErr" class="text-danger" v-text="emailMsg"></span>

                        <base-input class="input-group-alternative"
                                    placeholder="Password" :class="{'input-danger': passwordErr}"
                                    type="password" @keyup="passwordErr = false"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.password">
                        </base-input>
                        <span v-show="passwordErr" class="text-danger" v-text="passwordMsg"></span>

                        <!-- <div class="text-muted font-italic">
                            <small>password strength: <span class="text-success font-weight-700">strong</span></small>
                        </div> -->

                        <div class="row my-4">
                            <div class="col-12">
                                <base-checkbox class="custom-control-alternative">
                                    <span class="text-muted">I agree with the <a href="#!">Privacy Policy</a></span>
                                </base-checkbox>
                            </div>
                        </div>
                        <div class="text-center">
                            <base-button type="primary" class="my-4" @click.prevent="register">Create account</base-button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-6">
                    <a href="#" class="text-light">
                        <small>Forgot password?</small>
                    </a>
                </div>
                <div class="col-6 text-right">
                    <router-link to="/login" class="text-light">
                        <small>Login into your account</small>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'register',
    data() {
      return {
        model: {
          firstName: '',
          lastName: '',
          email: '',
          password: ''
        },
        firstNameErr: false,
        lastNameErr: false,
        emailErr: false,
        passwordErr: false,
        firstNameMsg: '',
        lastNameMsg: '',
        emailMsg: '',
        passwordMsg: '',
      }
    },
    methods: {
        register() {
            if(this.validateForm()) {
                this.firstNameErr = false;
                this.lastNameErr = false;
                this.emailErr = false;
                this.passwordErr = false;
                let {firstName, lastName, email, password} = this.model;
                let jsonData = {firstName, lastName, email, password};
                const requestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(jsonData)
                };
                fetch("http://localhost:8000/api/register", requestOptions)
                  .then(response => response.json())
                  .then(data => {
                    this.$router.push({ path: 'login' })
                  }
                );
            }
        },
        validateForm() {
            let hasErr = false;
            let {firstName, lastName, email, password} = this.model;
            if(!firstName) {
                this.firstNameErr = true;
                this.firstNameMsg = 'First Name is required.'
                hasErr = true;
            }
            if(!lastName) {
                this.lastNameErr = true;
                this.lastNameMsg = 'Last Name is required.'
                hasErr = true;
            }
            if(!email) {
                this.emailErr = true;
                this.emailMsg = 'Email is required.'
                hasErr = true;
            }
            if(!password) {
                this.passwordErr = true;
                this.passwordMsg = 'Password is required.'
                hasErr = true;
            }
            return !hasErr;
        }
    }
  }
</script>
<style scoped>
    .input-danger {
        border: 2px solid red;
        box-shadow: 0 0 2px red;
    }
    .text-danger {
        color: red;
        font-weight: bold;
        font-size: 14px;
    }
</style>
